<script setup lang="ts">
import { Minus, Plus } from 'lucide-vue-next'
interface Props {
  quantity: number
  tableGridClass: string
  showRequiredQuantity?: boolean
  readonly?: boolean
}

withDefaults(defineProps<Props>(), {
  showRequiredQuantity: false,
  readonly: false
})

const emit = defineEmits<{
  (e: 'change-quantity', delta: number): void
  (e: 'remove'): void
}>()
</script>

<template>
  <div class="grid items-center gap-0 border-b border-border p-3.5 last:border-b-0" :class="tableGridClass">
    <slot name="info" />

    <div v-if="showRequiredQuantity && !readonly" class="flex items-center justify-center gap-3.5">
      <Button
        variant="outline"
        size="icon"
        data-test="quantity-decrease"
        :disabled="quantity <= 1"
        @click="emit('change-quantity', -1)"
      >
        <Minus />
        <span class="sr-only">−</span>
      </Button>
      <div
        class="flex h-10 w-10 items-center justify-center rounded-control border border-border bg-white text-sm font-normal text-foreground"
      >
        {{ quantity }}
      </div>
      <Button variant="outline" size="icon" data-test="quantity-increase" @click="emit('change-quantity', 1)">
        <Plus />
        <span class="sr-only">+</span>
      </Button>
    </div>

    <div v-else-if="showRequiredQuantity" class="flex justify-center">
      <span class="text-sm font-normal text-foreground">
        {{ quantity }}
      </span>
    </div>

    <button
      v-if="!readonly"
      type="button"
      data-test="remove-row"
      class="justify-self-end flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground hover:bg-red-50 hover:text-red-600"
      @click="emit('remove')"
    >
      <BaseIcon name="HeroTrashIconOutline" class="h-5 w-5" />
    </button>
  </div>
</template>
